/**
 * Created By Elia Rohana on 12/3/18
 */
import { initialState } from '@ispm-client/modules/bpmn-modeler/store/state';
import {
    NodeConfigurationsAction,
    NodesConfigurationsActionTypes
} from '@ispm-client/modules/bpmn-modeler/store/actions';

export function nodeConfigurations(state = initialState.nodesConfigurations, action: NodeConfigurationsAction) {
    switch (action.type) {
        case NodesConfigurationsActionTypes.NODE_CONFIGURATION_CREATED:
        case NodesConfigurationsActionTypes.NODE_CONFIGURATION_EDITED:
            return { ...state, [action.payload.nodeId]: action.payload.configurations};
        default: {
            return state;
        }

    }

}
